import styled from 'styled-components';

import { Text } from '@gympass/yoga';

export const Container = styled.main`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  min-height: 100vh;
  height: 100%;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
`;

export const HeaderTitle = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
`;

export const AvailabilityContainer = styled.section`
  padding: ${({ theme }) => theme.yoga.spacing.zero}px
    ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.large}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.xlarge}px;

  & > section + section {
    margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  }

  @media screen and (max-width: 1024px) {
    padding: 0;
    margin-top: 0;
  }
`;
